import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message } from '../../components/';
import LoginWrapper from '../../components/login/LoginWrapper';

const mapStateToProps = state => {
    return {
        userState: state.get('user').toJS()
    };
};

@connect(mapStateToProps)
class SuccessView extends React.Component {
    static propTypes = {
        userState: PropTypes.object
    };

    render() {
        const { userState } = this.props;

        let content = '';

        const successContent = (
            <div className="success-block">
                <Message code="epic.esport.success.desc" />
            </div>
        );

        if (userState.isLoggedIn) {
            content = successContent;
        } else {
            content = <LoginWrapper productName="fortnite" />;
        }

        return (
            <div className="container" id="content">
                {content}
            </div>
        );
    }
}

export default SuccessView;
